













import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class FaqRecent extends Vue {
    loading: boolean = false;

    params: any = { per_page: 3, page: 1 };

    faqs: any = [];

    mounted() {
        this.getFaq();
    }

    private getFaq() {
        this.loading = true;

        // @ts-ignore
        axios
            .get("/api/faq", { params: { ...this.params } })
            .then((response: any) => (this.faqs = response.data.data))
            .finally(() => (this.loading = false));
    }
}
